import { useToast } from '@chakra-ui/react';
import CustomToast from '../common/CustomToast';

export const useMfaToast = () => {
  const toast = useToast();

  const showSuccessToast = (title, description = '') => {
    toast({
      render: ({ onClose }) => (
        <CustomToast
          status="success"
          title={title}
          description={description}
          onClose={onClose}
        />
      ),
    });
  };

  const showErrorToast = (title, description = '', duration = 5000) => {
    toast({
      render: ({ onClose }) => (
        <CustomToast
          status="error"
          title={title}
          description={description}
          onClose={onClose}
        />
      ),
      duration: duration,
    });
  };

  const showErrorToastWithDuration = (
    title,
    description = '',
    duration = 5000
  ) => {
    toast({
      render: ({ onClose }) => (
        <CustomToast
          status="error"
          title={title}
          description={description}
          onClose={onClose}
        />
      ),
      duration: duration,
    });
  };

  return {
    showSuccessToast,
    showErrorToast,
    showErrorToastWithDuration,
  };
};
